module.exports = __webpack_public_path__ + "img/26n.e4895e47.png";